var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-view-credits"},[_c('div',{staticClass:"c-view-credits-content"},[_c('styled-button',{attrs:{"to":"/"}},[_vm._v(" Back to title screen ")]),_c('credits',{staticClass:"c-view-credits-body"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }